<template>
<div class="chapter">
<div class="inner_page">
<h3>CONTENTS</h3>
<p class="paranoindent1"> </p>
<p class="toc-list1"><a href="#/06_Acknowledgement#acknowledgement" id="toc-acknowledgement">Acknowledgements</a></p>
<p class="toc-list1"><a href="#/07_Foreword#foreword" id="toc-foreword">Foreword by Brigadier Christopher Thursby-Pelham</a></p>
<p class="toc-list1"><a href="#/08_Prologue#prologue" id="toc-prologue">Prologue</a></p>
<p class="toc-list2"><a href="#/09_Chapter1#ch1" id="toc-ch1"><span class="label">Chapter I</span> Joining Up</a></p>
<p class="toc-list2"><a href="#/10_Chapter2#ch2" id="toc-ch2"><span class="label">Chapter II</span> Training</a></p>
<p class="toc-list2"><a href="#/11_Chapter3#ch3" id="toc-ch3"><span class="label">Chapter III</span> Advance to Battle</a></p>
<p class="toc-list2"><span href="#/12_Chapter4#ch4" id="toc-ch4" title="Link target outside of Sample"><span class="label">Chapter IV</span> Cassino</span></p>
<p class="toc-list2"><span href="#/13_Chapter5#ch5" id="toc-ch5" title="Link target outside of Sample"><span class="label">Chapter V</span> Cassino II</span></p>
<p class="toc-list2"><span href="#/14_Chapter6#ch6" id="toc-ch6" title="Link target outside of Sample"><span class="label">Chapter VI</span> The Battle Before Arce</span></p>
<p class="toc-list2"><span href="#/15_Chapter7#ch7" id="toc-ch7" title="Link target outside of Sample"><span class="label">Chapter VII</span> Perugia to Florence</span></p>
<p class="toc-list2"><span href="#/16_Chapter8#ch8" id="toc-ch8" title="Link target outside of Sample"><span class="label">Chapter VIII</span> The Gothic Line</span></p>
<p class="toc-list2"><span href="#/17_Chapter9#ch9" id="toc-ch9" title="Link target outside of Sample"><span class="label">Chapter IX</span> The Apennines to the Adriatic</span></p>
<p class="toc-list2"><span href="#/18_Chapter10#ch10" id="toc-ch10" title="Link target outside of Sample"><span class="label">Chapter X</span> The Po, the Alps and Austria</span></p>
<p class="toc-list1"><span href="#/19_Epilogue#epilogue" id="toc-epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc-list2"><span href="#/20_Appendix1#app1" id="toc-app1" title="Link target outside of Sample"><span class="label">Appendix I:</span> The Four Battles of Cassino</span></p>
<p class="toc-list2"><span href="#/21_Appendix2#app2" id="toc-app2" title="Link target outside of Sample"><span class="label">Appendix II:</span> The Assault on the Gothic Line</span></p>
<p class="toc-list2"><span href="#/22_Appendix3#app3" id="toc-app3" title="Link target outside of Sample"><span class="label">Appendix III:</span> Repatriation Agreements</span></p>
<p class="toc-list2"><span href="#/23_Appendix4#app4" id="toc-app4" title="Link target outside of Sample"><span class="label">Appendix IV:</span> War Diary</span></p>
<p class="toc-list1"><span href="#/24_Index#index" id="toc-index" title="Link target outside of Sample">Index:</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?64787b30